import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var deleteTier = createAction(actionKey + ".DELETE_TIER", function (deviation) { return ({ deviation: deviation }); });
export var updateTier = createAction(actionKey + ".UPDATE_TIER", function (payload) { return payload; });
export var saveTierAsDraft = createAction(actionKey + ".SAVE_TIER_DRAFT", function (payload) { return payload; });
export var publishTier = createAction(actionKey + ".PUBLISH_TIER", function (payload) { return payload; });
export var tierRequestError = createAction(actionKey + ".TIER_ERROR", function (message, details) {
    if (details === void 0) { details = {}; }
    return ({
        message: message,
        details: details,
    });
});
export var tierRequestSuccess = createAction(actionKey + ".TIER_SUCCESS", function (message, details) {
    if (message === void 0) { message = ''; }
    if (details === void 0) { details = {}; }
    return ({
        message: message,
        details: details,
    });
});
//# sourceMappingURL=actions.js.map